import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import moment from 'moment';

import { showSuccessSnackbar } from 'modules/snackbar';
import { contentsCategory } from 'lib/api/common';
import {
  dayColor,
  makeRowColumn,
  getHeadObj,
  dataConverter,
} from 'lib/commonLib';
import { addAllList } from 'modules/common';
import { audienceConversion } from 'lib/api/datacenter';

import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';
import NewCategoryFilter from 'components/organisms/NewCategoryFilter';

const AudienceConversionList = ({ displayFilterList, location }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  let initParams = {
    sort: 'desc',
    order: 'STATS_DTTM',
    sDate: moment().add(-1, 'month').add(-1, 'day').format('YYYYMMDD'),
    eDate: moment().add(-1, 'day').format('YYYYMMDD'),
    adcFstRnk: 'all',
    pltfomTpCode: 'all',
  };
  //데이터센터 - 오디언스타겟팅통계 (sDate, eDate, adcFstRnk, advrtsPrdtCode, advrtsTpCode, ctgrSeq)
  const convertKeys = [
    'sDate',
    'eDate',
    'advrtsPrdtCode',
    'advrtsTpCode',
    'pltfomTpCode',
    'adcFstRnk',
    'ctgrSeq',
  ];
  const newInitParams = dataConverter(
    queryString.parse(location.search),
    convertKeys
  );
  initParams = {
    ...initParams,
    ...newInitParams,
  };
  if (!!initParams['adcFstRnk']) {
    initParams['adcFstRnk'] = Number(initParams['adcFstRnk']);
  }
  if (!!initParams['ctgrSeq']) {
    initParams['ctgrSeq'] = Number(initParams['ctgrSeq']);
  }

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const [contentCategory, setContentCategory] = useState([]);

  useEffect(() => {
    contentsCategory()
      .then((response) => {
        const { data } = response.data;
        setContentCategory(data);
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error,
          option: {
            type: 'error',
          },
        });
      });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  // header 및 body 컬럼 커스텀
  const customized = {
    STATS_DTTM: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'STATS_DTTM').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        return dayColor(
          makeRowColumn(rowObj['STATS_DTTM'], 'date', 'YYYY-MM-DD')
        );
      },
      bodyStyle: {
        minWidth: 100,
        textAlign: 'center',
      },
    },
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  /**
   * 스낵바 리덕스 값을 변경해주는 함수
   * @type {(...args: any[]) => any}
   */
  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <NewFilterWrap>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          displayFilterList={displayFilterList}
          useExternalFilter={false}
        />
        <FilterCollection
          label={t('컨텐츠 카테고리')}
          name="adcFstRnk"
          params={params}
          value={params.adcFstRnk}
          type="select"
          list={addAllList(contentCategory, 'CTGR_NM', 'CTGR_SEQ', 'all')}
          callBack={getParam}
          labelKey="CTGR_NM"
          valueKey="CTGR_SEQ"
        />
        <NewCategoryFilter params={params} getParam={getParam} />
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={audienceConversion}
        customized={customized}
        useTotal={false}
        useFetch={false}
      />
    </>
  );
};

export default withRouter(AudienceConversionList);
